<template>
  <div
    class="app-shell tw:relative tw:isolate tw:w-full tw:max-w-(--app-frame-width) tw:h-dvh tw:m-auto tw:pt-(--app-safe-top)"
    :class="{ 'has-navigation': navigation }"
  >
    <div
      ref="viewport"
      class="app-shell__viewport tw:h-full tw:overflow-y-auto tw:pb-(--viewport-bottom-clearance)"
    >
      <slot />
    </div>
    <div
      v-if="navigation"
      class="app-shell__navigation tw:absolute tw:bottom-(--app-navigation-bottom)"
    >
      <slot name="navigation" />
    </div>
  </div>
</template>

<script setup>
// 1. Import necessary components
import { onMounted, watch, ref } from 'vue';
import { useFocusVisibility } from '@/shared/composables/useFocusVisibility';
import { useRoute } from 'vue-router';
import { Capacitor, SystemBars, SystemBarsStyle } from '@capacitor/core';
// 2. Use
defineProps({ navigation: { type: Boolean, default: false } });
const route = useRoute();
// 3. Define a reactive variable
const viewport = ref(null);
// 4. Define methods or computed properties if needed
// 5. VueJS Hooks
useFocusVisibility(viewport);
watch(
  () => route.path,
  () => viewport.value?.scrollTo({ top: 0 }),
);
onMounted(async () => {
  if (Capacitor.isNativePlatform()) {
    await SystemBars.setStyle({ style: SystemBarsStyle.Light });
  }
});
</script>

<style scoped>
.app-shell {
  overflow: clip;
  background: var(--background);
}
.app-shell__viewport {
  --viewport-bottom-clearance: var(--app-safe-bottom);
  overscroll-behavior-y: contain;
  scroll-padding-block: 0 var(--viewport-bottom-clearance);
  scrollbar-width: none;
}
.has-navigation .app-shell__viewport {
  --viewport-bottom-clearance: calc(
    var(--app-navigation-height) + var(--app-navigation-bottom) + 2.5rem
  );
}
.app-shell__navigation {
  z-index: 20;
  inset-inline: var(--app-navigation-inline);
}
.app-shell:has(.page-actions) .app-shell__viewport {
  --viewport-bottom-clearance: calc(5.25rem + var(--app-action-bottom));
}
</style>
